/**
 * 短视频/口播文案 AI 改写
 * POST /changewenan — content + types
 */
import api from '@/utils/api'

export const REWRITE_TYPES = [
  { key: 'polish', label: '润色' },
  { key: 'mimic', label: '仿写' },
  { key: 'simplify', label: '精简' },
  { key: 'expand', label: '扩写' }
]

/**
 * @param {string} content 原文案
 * @param {'polish'|'mimic'|'simplify'|'expand'} types 改写类型
 * @returns {Promise<string>}
 */
export async function rewriteVideoCopy(content, types) {
  const text = String(content || '').trim()
  if (!text) throw new Error('没有可改写的文案')
  const action = String(types || '').trim()
  if (!action) throw new Error('请选择改写类型')

  const res = await api.post('/changewenan', {
    content: text,
    types: action
  })

  if (res && res.msg === 'success' && res.data) {
    return String(res.data).trim()
  }

  const msg = (res && (res.error || res.msg)) || '文案改写失败，请稍后重试'
  throw new Error(typeof msg === 'string' ? msg : '文案改写失败')
}
